<template>
  <div class="ui form" ref="form">
    <h4 class="ui dividing header">{{ $t("pre-inscribe to") }}</h4>
    <!-- <h5
      class="ui header"
      v-show="
        inscription_configuration &&
          inscription_configuration.send_to_assignation &&
          pensum &&
          pensum.pnm_pensum_distributions
      "
    >
      {{ $t("select the courses the student will be taken") }}
    </h5> -->
    <div
      class="field"
      v-show="
        inscription_configuration &&
          inscription_configuration.send_to_assignation == true
      "
    >
      <!-- <pre>{{ inscription_configuration }}</pre> -->
      <label>{{ $t("course") }}</label>
      <div class="ui search" ref="course_search">
        <div class="ui icon input">
          <input
            class="prompt"
            type="text"
            :placeholder="$t('search course')"
          />
          <i class="search icon"></i>
        </div>
        <div class="results"></div>
      </div>
    </div>
    <div
      class="ui relaxed list"
      v-if="pensum && pensum.pnm_pensum_distributions"
    >
      <!-- <pre>{{ pensum }}</pre> -->
      <div
        class="item"
        v-for="(dist, cidx) in pensum.pnm_pensum_distributions"
        :key="cidx"
      >
        <!-- <i class="book middle aligned icon"></i> -->
        <div class="content">
          <div
            class="ui tiny basic icon right floated button"
            @click="delete_course(cidx)"
          >
            <i class="red trash icon"></i>
          </div>
          <i class="blue book icon"></i>{{ dist.crs_course.name }}
        </div>
      </div>
    </div>
    <div v-else class="ui visible warning message">
      <div class="content">
        <div class="header">
          {{ $t("alert") }}
        </div>
        <p>
          {{
            $t(
              "no courses configured in pensum for this career / studying cycle",
            )
          }}
        </p>
      </div>
    </div>
    <!-- <pre>{{ inscription_configuration }}</pre> -->
  </div>
</template>

<script>
import { local_api, error_toast, init_search } from "@/utils";

export default {
  name: "StudentInscriptionInscriptionModalPensumCourses",
  data() {
    return {
      pensum: undefined,
    };
  },
  props: {
    // pensum: Object,
    inscription_configuration: Object,
    career: String,
    studying_cycle: String,
    studying_time: String,
  },
  methods: {
    update() {
      let vm = this;
      if (vm.career && vm.studying_cycle) {
        local_api(vm, "post", "/pensum_inscription/do-get-courses", {
          c: vm.career,
          y: vm.studying_cycle,
        })
          .then((pensum) => {
            // if (pensum) {
            //   pensum.pnm_pensum_distributions = pensum.pnm_pensum_distributions.map(
            //     (d) => {
            //       d.is_selected = true;
            //       return d;
            //     },
            //   );
            // }
            vm.pensum = pensum;
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    getCourses() {
      let vm = this;
      if (
        vm.pensum &&
        vm.pensum.pnm_pensum_distributions &&
        vm.pensum.pnm_pensum_distributions.length > 0
      ) {
        return this.pensum.pnm_pensum_distributions.map((d) => {
          return {
            course_id: d.crs_course.course_id,
            //   is_selected: d.is_selected,
          };
        });
      } else {
        return [];
      }
    },
    delete_course(cidx) {
      this.pensum.pnm_pensum_distributions.splice(cidx, 1);
    },
  },
  watch: {
    studying_time() {
      this.update();
    },
    studying_cycle() {
      this.update();
    },
    career() {
      this.update();
    },
  },
  mounted() {
    let vm = this;
    setTimeout(() => {
      let onSearchSelect = function(data) {
        if (!vm.pensum) vm.pensum = { pnm_pensum_distributions: [] };
        vm.pensum.pnm_pensum_distributions.push({
          crs_course: {
            course_id: data.course.course_id,
            name: data.course.name,
          },
        });
      };
      let onSearchResponse = (data) => {
        let rslt = [];
        data.map((r) => {
          rslt.push({
            title: r.name,
            description: r.name,
            course: r,
          });
        });
        return { results: rslt };
      };

      init_search(
        vm,
        vm.$refs.course_search,
        "search course",
        onSearchResponse,
        onSearchSelect,
      );
    }, 500);
  },
};
</script>
